export default __webpack_public_path__ + "static/house5-40a35ff7ed84d07fd398613c41da8f0f.png";